import { render, staticRenderFns } from "./VCard.vue?vue&type=template&id=1a3dea2c&"
import script from "./VCard.vue?vue&type=script&lang=ts&"
export * from "./VCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports